import React, { useState, useEffect, useRef } from "react";
import Popup from "reactjs-popup";
import axios from "axios";
import Cookies from "js-cookie";
import Loader from '../../utils/loader';
import { toast } from "../../utils/toast";
import { errorMessage } from "../../utils/errorMessage";
import { useSubmitGuard } from "../../utils/useSubmitGuard";
import { API_DETAILS, COOKIE_KEYS } from "../../App";

const SymptomCalculator = (props) => {
  const nextButtonRef = useRef(null);
  const [chooseDiagnosis, setChooseDiagnosis] = useState(true);
  const [choosenDiagnosis, setChoosenDiagnosis] = useState(false);

  const [questionnaire, setquestionnaire] = useState([]);
  const [userResponse, setUserResponse] = useState([]);
  const [selDiag, setDiagName] = useState("");
  const [diagId, setDiagId] = useState("");
  const [diagnosisNames, setDiagnoses] = useState([]);
  const [symptomScore, setSymptomScore] = useState(-1);
  const [symptomScorePage, setSymptomScorePage] = useState(false);
  const [selectedOption, setSelectedOption] = useState(-1);
  const [qId, setQId] = useState(0);
  const [currentQid, setCurrentQid] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [currentChildQuestionIndex, setCurrentChildQuestionIndex] = useState(0);
  const [initialCondition, setInitialCondition] = useState(true);
  /**
   * A question with no options is a free-text answer.
   *
   * This used to be a hardcoded list of question ids, `[302, 303, 304, 305]`,
   * so every new free-text follow-up added to the database also needed a code
   * change here — and silently rendered as an empty question until someone made
   * it. Reading it off the data means the database alone decides.
   */
  const isFreeTextQuestion = (question) => !question?.options?.length;

  /**
   * "Check all that apply" questions are the multi-select ones. This was
   * hardcoded to question id 279, the past-medical-history question.
   */
  const isMultiSelectQuestion = (question) =>
    typeof question?.question === "string" &&
    question.question.toLowerCase().includes("check all that apply");
  const [listAllQuestion, setListAllQuestion] = useState(false);
  const [isMultiOption, setIsMultiOption] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // Guards the final save only. Back is not guarded: handleBack calls itself to
  // skip questions that were never shown, and a lock would stop that recursion.
  const [, guard] = useSubmitGuard();

  const [userName, setUserName] = useState("");
  const [errors, setErrors] = useState({});
  const [severityDescription, setSeverityDescription] = useState("");
  const [isBackNavigation, setIsBackNavigation] = useState(0);
  const [textResponses, setTextResponses] = useState({});

  useEffect(() => {
    fetchAllDiagnoses();
    setDiagName(props.diagName);
  }, []);


  useEffect(() => {
   // console.log(props.diagId);
   console.log("setDiagName",selDiag);
    setDiagId(props.diagId);
    setDiagName(props.diagName);
    //setChoosenDiagnosis(props.choosenDiagnosis);
  }, [props.diagId,props.choosenDiagnosis,props.diagName])

  useEffect(() => {
    console.log("choosenDiagnosis is : ,",selDiag);
    // Update the state and trigger click event on Next button
    if (selDiag && nextButtonRef.current) {
        nextButtonRef.current.click(); // Programmatically click the Next button
    }
  }, [selDiag])

  // The appointment decides Initial or Follow-up, and lets the server refuse a
  // questionnaire that can't be taken before the first question. Never for the
  // intake form, which isn't tied to the appointment's window.
  const appointmentIdForQuestions =
    props.apptId && !props.fromLandingPage && selDiag !== "Intake Form" ? props.apptId : 0;

  // A refusal the server explains ("opens on Tue, Oct 6", "already completed")
  // is shown; anything else was being dropped silently into the console.
  const showQuestionLoadError = (err) => {
    console.error(err);
    toast.error(errorMessage(err, "We couldn't load the next question. Try again in a moment."));
  };

  const fetchQuesByDiagId = async () => {
    const temp = {
      questionnaire_type: selDiag,
      last_question_id: qId,
      selected_option_id: selectedOption,
      patient_id: props.uId,
      diagId: diagId,
      is_back_navigation: isBackNavigation,
      appointment_id: appointmentIdForQuestions,
    };
    const url =
      API_DETAILS.baseUrl +
      API_DETAILS.PORT +
      API_DETAILS.baseExtension +
      "/getQuestionsByQuestionnaireType";

    setIsLoading(true);
    axios
      .post(url, temp)
      .then((res) => {
        console.log(res);

        setquestionnaire(res.data);
        setListAllQuestion(isFreeTextQuestion(res.data[0]));
        setIsMultiOption(isMultiSelectQuestion(res.data[0]));
        console.log("current question qid:", res.data[0].questionId);
        setCurrentQid(res.data[0].questionId);
        const prevResponse = userResponse.find(
          (response) => response.qId === res.data[0].questionId
        );

        // Point the outgoing last_question_id at whatever is on screen, and
        // clear any option carried over from the question before it.
        //
        // Without this, a question the patient never touches leaves both set to
        // the previous question's values, so Next asks the server the same thing
        // again and the same question comes back — a free-text follow-up could
        // not be skipped, which it has to be when the patient does not know the
        // answer. The server derives the parent from last_question_id, so with
        // the right id and no option it moves on to the next question.
        setQId(res.data[0].questionId);
        if (!prevResponse) {
          setSelectedOption(0);
        }

        if (prevResponse) {
          const optionId = prevResponse.optionsData[0]?.oId || 0;
          setSelectedOption(optionId);
          setQId(res.data[0].questionId)
        }
      })
      .catch((err) => {
        showQuestionLoadError(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleBack = (currentQidParam) => {
    const questionIndex = currentQidParam || currentQid;
    const temp = {
      questionnaire_type: selDiag,
      last_question_id: questionIndex,
      selected_option_id: selectedOption,
      patient_id: props.uId,
      diagId: diagId,
      is_back_navigation: 1,
      appointment_id: appointmentIdForQuestions,
    };
    const url =
      API_DETAILS.baseUrl +
      API_DETAILS.PORT +
      API_DETAILS.baseExtension +
      "/getQuestionsByQuestionnaireType";

    setIsLoading(true);
    axios
      .post(url, temp)
      .then((res) => {
        console.log(res);

        const prevQuestionId =  res.data[0].questionId;
        const prevResponse = userResponse.find((response) => response.qId === prevQuestionId);
        if (!prevResponse) {
          handleBack(prevQuestionId);
          return;
        }
        setquestionnaire(res.data);
        setListAllQuestion(isFreeTextQuestion(res.data[0]));
        setIsMultiOption(isMultiSelectQuestion(res.data[0]));
        setCurrentQid(res.data[0].questionId);
        console.log("Back question id, currentqId", res.data[0].questionId, currentQid)
        
        if (prevResponse) {
          const optionId = prevResponse.optionsData[0]?.oId || 0;
          setSelectedOption(optionId);
          if (optionId < 0) {
            setTextResponses((prev) => ({
              ...prev,
              [prevResponse.qId]: prevResponse.optionsData[0].oName,
            }));
          }
          setQId(res.data[0].questionId)
        }
      })
      .catch((err) => {
        showQuestionLoadError(err);
      })
      .finally(() => {
        setIsLoading(false);
      });

      var userResponses = [...userResponse];
      setCurrentChildQuestionIndex(currentChildQuestionIndex - 1);
      setCurrentQuestionIndex(currentQuestionIndex - 1);
  };

  const fetchAllDiagnoses = async () => {
    const url =
      API_DETAILS.baseUrl +
      API_DETAILS.PORT +
      API_DETAILS.baseExtension +
      `/getAllDiagnoses`;
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Content-Type": "application/json",
      },
    };

    setIsLoading(true);
    try {
      const res = await axios.get(url, config);
      setDiagnoses(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const [newScore, setNewScoreInfo] = useState({});
  const saveNewSymptomScore = guard(async (data) => {
    let api = "";
    if (props.fromLandingPage) {
      api = "/saveScore";
    } else {
      api = "/saveSymptomScore";
    }
    const url =
      API_DETAILS.baseUrl +
      API_DETAILS.PORT +
      API_DETAILS.baseExtension +
      api;

    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Content-Type": "application/json",
      },
    };

    setIsLoading(true);
    try {
      const res = await axios.post(url, data, config);
      setDiagnoses(res.data);
      console.log(res.data);
      setNewScoreInfo(res.data);
      setSeverityDescription(getSeverityDescription(res.data.score));
      if (diagId != 0 && !props.fromLandingPage) setSymptomScorePage(true);
      else props.setOpen(false);
    } catch (err) {
      // Was console-only, so a refused questionnaire ("has closed", "already
      // completed") looked to the patient like a button that did nothing.
      console.error(err);
      toast.error(errorMessage(err, "We couldn't submit your questionnaire. Check your answers and try again."));
    } finally {
      setIsLoading(false);
      if (!props.fromLandingPage && props.onSubmitRefresh) {
        props.onSubmitRefresh();
      }
    }
    if (props.fetchSymptomScore && diagId != 0) {
      props.fetchSymptomScore(true);
    }
  });

  const handleNext = () => {
    console.log("====^^^===");
    console.log("handleNext START");

    setSelectedOption(0);
    setCurrentQuestionIndex(currentQuestionIndex + 1);
    fetchQuesByDiagId();

    if (!props.fromLandingPage && questionnaire.length === 0) {
      const now = new Date();
      const temp = {
        diagnosisId: diagId,
        questionData: userResponse,
        appointmentId: props.apptId,
        patientId: parseInt(Cookies.get(COOKIE_KEYS.userId)),
      };
      // console.log("props.apptId:",props.apptId);

      saveNewSymptomScore(temp);
    } else if (props.fromLandingPage && questionnaire.length === 0) {
      const now = new Date();
      const temp = {
        questionData: userResponse,
        email: userName,
        questionnaire_type: selDiag,
        diagnosisId: diagId,
      };
      saveNewSymptomScore(temp);
    }

    console.log("handleNext END");
    console.log("====^^^===");
  };

  const handleResponseList = (qId, question, text) => {
    // TODO: Handle in a better way, -100 -> not option data
    const option = {oId: -100, oName: text};
    setSelectedOption(-100);
    setQId(qId);
    var userResponses = [...userResponse];
    const existingResponseIndex = userResponses.findIndex(response => response.qId === qId);
    if (existingResponseIndex !== -1) {
      console.log("data in questionNum index already exists");
      userResponses[existingResponseIndex] = {
        qId: qId,
        question: question,
        optionsData: [option],
      };
    } else {
      userResponses.push({
        qId: qId,
        question: question,
        optionsData: [option],
      });
    }
    setUserResponse(userResponses);
    console.log(userResponses);
  }

  const handleResponse = (qId, question, oId, option, isCheckbox) => {
    setQId(qId);

    if (isCheckbox) {
      setSelectedOptions((prevSelectedOptions) => {
        const next = prevSelectedOptions.includes(oId)
          ? prevSelectedOptions.filter((id) => id !== oId)
          : [...prevSelectedOptions, oId];

        // Only one option id travels to the server as selected_option_id, and
        // it is what the follow-up question is looked up by. Ticking a checkbox
        // used to leave it untouched, holding whatever the previous question
        // set, so a follow-up hanging off a multi-select answer — the cancer
        // type, say — could never be reached. Send a ticked option that
        // actually has something behind it, and 0 when none do.
        const currentQuestion = questionnaire?.[0];
        const followUp = (currentQuestion?.options || []).find(
          (o) => next.includes(o.oId) && o.hasFollowUpQuestion
        );
        setSelectedOption(followUp ? followUp.oId : 0);

        return next;
      });
    } else {
      setSelectedOption(oId);
    }

    var userResponses = [...userResponse];
    const existingResponseIndex = userResponses.findIndex(response => response.qId === qId);
    console.log(userResponses);
    if (existingResponseIndex !== -1) {
      console.log("data in questionNum index already exists");

      if (isCheckbox) {
        const optionsData = userResponses[existingResponseIndex].optionsData;
        if (!optionsData.some((opt) => opt.oId === oId)) {
            userResponses[existingResponseIndex].optionsData.push(option);
        } else {
          userResponses[existingResponseIndex].optionsData = optionsData.filter((opt) => opt.oId !== oId);
        }
      } else {
        userResponses[existingResponseIndex] = {
          qId: qId,
          question: question,
          optionsData: [option],
        };
      }
    } else {
      userResponses.push({
        qId: qId,
        question: question,
        optionsData: [option],
      });
    }
    setUserResponse(userResponses);
    console.log(userResponses);
  };

  const handleDiagChange = (event) => {
    console.log(event.target.value);
    const selectedDiagnosis = JSON.parse(event.target.value);
    const { id, name } = selectedDiagnosis;
    setDiagId(id);
    setDiagName(name);
  };
  const onClickHandler = () => {
    console.log('initial Condition',initialCondition);
    if (initialCondition) {
      if (props.isIntakeForm || diagId != 0) {
        fetchQuesByDiagId();
        setInitialCondition(false);
      }
    } else if (
      questionnaire.length > 1 &&
      currentChildQuestionIndex !== questionnaire.length - 1
    ) {
      handleNextQuestion();
    } else {
      handleNext();
    }
  };
  const handleNextQuestion = () => {
    setSelectedOption(0);
    setCurrentChildQuestionIndex(currentChildQuestionIndex + 1);
    setCurrentQuestionIndex(currentQuestionIndex + 1);
  };
  const currentQuestion = questionnaire[currentChildQuestionIndex];
  

  const handleChange = (event) => {
    const { name, value } = event.target;
    setUserName(value);
    validateEmail(name, value);
  };

  const validateEmail = (name, value) => {
    const maxLength = 32;
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const newErrors = {};
    if (!value.trim()) {
      newErrors.required = true;
    } else {
      delete newErrors.required;
    }

    // Check maxLength
    if (value.length > maxLength) {
      newErrors.maxLength = true;
    } else {
      delete newErrors.maxLength;
    }

    // Check email pattern
    if (!pattern.test(value)) {
      newErrors.pattern = true;
    } else {
      delete newErrors.pattern;
    }

    setErrors(newErrors);
  };
  const getScoreColor = (score) => {
    if (score <= 25) return "#FF0000"; // Red for severe
    if (score <= 50) return "#FFA500"; // Orange for moderate
    if (score <= 75) return "#FFFF00"; // Yellow for mild
    return "#008000"; // Green for very mild
  };
  const getSeverityDescription = (score) => {
    console.log(score)
    if (score <= 25) {
      return (
        <>
          <h2>Severely Bothersome Symptoms</h2>
          <p style={{ fontSize: "20px" }}>
            Your symptoms are likely significantly interfering with your ability to perform activities such as
            sleeping, socializing, working, or running errands. They may be causing substantial distress and
            affecting your overall well-being.
          </p>
        </>
      );
    }
    if (score <= 50) {
      return (
        <>
          <h2>Very Bothersome Symptoms</h2>
          <p style={{ fontSize: "20px" }}>
            Your symptoms likely have a large impact on your ability to carry out daily activities such as sleeping,
            socializing, working, or running errands. They may be causing considerable discomfort and affecting your
            overall well-being.
          </p>
        </>
      );
    }
    if (score <= 75) {
      return (
        <>
          <h2>Moderately Bothersome Symptoms</h2>
          <p style={{ fontSize: "20px" }}>
            Your symptoms are likely causing notable disruption in your daily life. You are able to perform daily
            activities such as sleeping, socializing, working, or running errands, but with some difficulty or
            discomfort.
          </p>
        </>
      );
    }
    return (
      <>
        <h2>Mildly Bothersome Symptoms</h2>
        <p style={{ fontSize: "20px" }}>
          Your symptoms are likely causing some level of discomfort and inconvenience, but they are not significantly
          impacting your daily life. You may be aware of the symptoms but they are generally tolerable and do not
          impact your ability to accomplish daily tasks such as sleeping, socializing, working, or running errands.
        </p>
      </>
    );
  };

  // Click handler for the circle to show the severity description
  const handleScoreClick = () => {
//    setSeverityDescription(getSeverityDescription(newScore.score));
  };

  const headerStyle = {
    fontSize: "30px",
    textAlign: "center",
    marginBottom: "20px",
    backgroundColor: "#9CB189",
    padding: "30px 20px",
    borderRadius: "8px",
  };

  return (
    <Popup
      open={props.open}
      modal
      closeOnDocumentClick={false}
      onClose={() => {
        props.setOpen(false);
      }}
      style={{ position: "relative" }}
      className="symptom-popup"
    >
      <div
        style={{
          position: "absolute",
          top: "20px",
          right: "20px",
          cursor: "pointer",
        }}
        onClick={() => {
          if (props.isIntakeForm && !props.editIntake) {
            toast.error("Complete the intake form to continue. Your provider uses it to prepare for your visit.");
          } else {
            props.setOpen(false);
          }
        }}
      >
        <span class="material-symbols-outlined">close</span>
      </div>
      <div style={{ padding: "30px 50px" }}>
        <div style={{ textAlign: "center" }}>
          {!symptomScorePage && !props.isIntakeForm && (
            <>
              <h2 style={headerStyle}>Symptom Calculator</h2>
              {questionnaire.length === 0 && (
                <>{initialCondition ? <p>Choose the diagnosis</p> : <p></p>}</>
              )}
            </>
          )}
          {!symptomScorePage && props.isIntakeForm && (
            <>
              <h2 style={headerStyle}>Intake Form</h2>
            </>
          )}
          <br />
        </div>

        <div style={{ textAlign: "start", fontSize: "18px", marginTop: "10px" }}>
          {initialCondition && chooseDiagnosis && (
            <div
              style={{ display: "flex", fontSize: "15px", marginTop: "10px", flexWrap: "wrap", maxHeight: "54vh", overflowY:"auto", overflowX:"hidden" }}
            >
              {diagnosisNames.map((diagnosis) => {
                return (
                  <div key={diagnosis.diagId}  style={{ width: "300px" }}>
                    <input
                      type="radio"
                      id= {`diagnosis-${diagnosis.diagId}`}
                      name="diagnosis"
                      value={JSON.stringify({
                        id: diagnosis.diagId,
                        name: diagnosis.name,
                      })}
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        MozAppearance: "none"
                      }}
                      onChange={handleDiagChange}
                      checked={selDiag === diagnosis.name}
                    />
                    <label for= {`diagnosis-${diagnosis.diagId}`}  style={{ marginLeft: "10px", position: "relative", top: "-3px" }}>
                      {diagnosis.name}
                    </label>
                    <br />
                    <br />
                  </div>
                );
              })}
            </div>
          )}
          {chooseDiagnosis ? (
            symptomScorePage ? (
              <div style={{ textAlign: "center"}}>
                <p>
                  Diagnosis Name: <strong>{newScore.diagName}</strong>
                </p>
                <h2>Your Symptom Score</h2>
                <br></br>
                <div
                onClick={() => {
                  handleScoreClick();
                }}
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  backgroundColor: getScoreColor(newScore.score),
                  color: "#000",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  margin: "0 auto", // This centers the circle horizontally
                  position: "relative",
                }}
              >
                {newScore.score}
              </div>
              {severityDescription && (
              <div style={{ marginTop: "10px" }}>
                {severityDescription}
              </div>
            )}
              </div>
            ) : (
              <div>
                <div>
                  {questionnaire.length === 1 && (
                    <>
                      {questionnaire.map((question) => (
                        <div key={question.questionId}>
                          <p>{question.question}</p>

                          {listAllQuestion ? (
                            <div>
                              <input
                                type="text"
                                placeholder="Enter text"
                                pattern="[A-Za-z.,]*"
                                title="Only alphabetic characters, commas, and full stops are allowed"
                                value={textResponses[question.questionId] || ''}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setTextResponses((prev) => ({
                                    ...prev,
                                    [question.questionId]: value,
                                  }));
                                  handleResponseList(question.questionId, question.question, e.target.value);
                                }}
                                style={{ width: "100%", padding: "8px", margin: "10px 0", borderRadius: "4px", border: "1px solid #ccc" }}
                              />
                            </div>
                          ) : (
                            !isMultiOption && question.options.map((option) => {
                              return (
                                <div style={{ marginLeft: "0px" }}>
                                  <input
                                    type="radio"
                                    id={`option-${option.oId}`}
                                    name={`question-${question.questionId}`}
                                    value={option.oId}
                                    checked={selectedOption === option.oId}
                                    onChange={() =>
                                      handleResponse(
                                        question.questionId,
                                        question.question,
                                        option.oId,
                                        option,
                                        false
                                      )
                                    }
                                    style={{
                                      appearance: "none",
                                      WebkitAppearance: "none",
                                      MozAppearance: "none"
                                    }}
                                  />
                                  <label style={{ display: "inline", wordWrap: "break-word", whiteSpace: "normal", marginLeft: "10px", lineHeight: "1.4" }}
                                    htmlFor={`option-${option.oId}`}
                                  >
                                    {option.oName}
                                  </label>
                                </div>
                              );
                            })
                          )}

                          { isMultiOption && question.options.map((option) => {
                            return (
                              <div style={{ marginLeft: "0px" }}>
                                <input
                                  type="checkbox"
                                  id={`option-${option.oId}`}
                                  name={`question-${question.questionId}`}
                                  value={option.oId}
                                  checked={selectedOptions.includes(option.oId)}
                                  onChange={() =>
                                    handleResponse(
                                      question.questionId,
                                      question.question,
                                      option.oId,
                                      option,
                                      true
                                    )
                                  }
                                  style={{
                                    appearance: "checkbox",
                                    WebkitAppearance: "checkbox",
                                    MozAppearance: "checkbox"
                                  }}
                                />
                                <label style={{ wordWrap: "break-word", whiteSpace: "normal", marginLeft: "10px", lineHeight: "1.4" }}
                                  htmlFor={`option-${option.oId}`}
                                >
                                  {option.oName}
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      ))}
                    </>
                  )}
                  {questionnaire.length > 1 && (
                    <>
                      {
                        <div key={currentQuestion?.questionId}>
                          <p>{currentQuestion?.question}</p>

                          {currentQuestion.options.map((option) => {
                            return (
                              <div style={{ marginLeft: "0px" }}>
                                <input
                                  type="radio"
                                  id={`option-${option.oId}`}
                                  name={`question-${currentQuestion.questionId}`}
                                  value={option.oId}
                                  checked={selectedOption === option.oId}
                                  onChange={() =>
                                    handleResponse(
                                      currentQuestion.questionId,
                                      currentQuestion.question,
                                      option.oId,
                                      option,
                                      false
                                    )
                                  }
                                  style={{appearance: "none", WebkitAppearance: "none", MozAppearance: "none"}}
                                />
                                <label
                                  style={{ marginLeft: "10px", position: "relative", top: "-3px" }}
                                  htmlFor={`option-${option.oId}`}
                                >
                                  {option.oName}
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      }
                    </>
                  )}
                  {!initialCondition && !isLoading && questionnaire.length === 0 && (
                    <div style={{ textAlign: "center" }}>
                      Thank You for taking this survey!!!
                    </div>
                  )}
                </div>
              </div>
            )
          ) : (
            ""
          )}
        </div>
        <div
          style={{
            position: "absolute",
            display: "flex",
            justifyContent: "center",
            gap: "20px",
            bottom: "4%",
            width: "80%",
        }}
        >
        {(currentQuestionIndex > 0 || currentChildQuestionIndex > 0) && !(!initialCondition && questionnaire.length === 0)  ? (
        <div
          className="btn-filled"
          style={{
          width: "fit-content",
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
          padding: "10px 20px",
          height: "40px"
          }}
          onClick={() => handleBack()}
        >
        Back
        </div>
        ) : null}

        {(initialCondition || questionnaire.length !== 0) && (
          <div
            className={
              ((selectedOption === 0 || selectedOption === -1) && selectedOptions.length == 0) ? "btn-filled-disabled" : "btn-filled"
            }
            style={{
              width: "fit-content",
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              padding: "10px 20px",
              height: "40px"
            }}
            onClick={onClickHandler}
            ref={nextButtonRef}
          >
            Next
          </div>
        )}
        </div>

        {!initialCondition && !isLoading &&
          questionnaire.length === 0 &&
          !symptomScorePage &&
          props.fromLandingPage && (
            <>
              <div>
                <label>Email: </label>
                <input
                  className="input-field input-border"
                  type="text"
                  value={userName}
                  onChange={handleChange}
                />
                {errors.required && (
                  <p className="error-text">This field is required</p>
                )}
                {errors.maxLength && (
                  <p className="error-text">
                    Email cannot exceed 32 characters
                  </p>
                )}
                {errors.pattern && (
                  <p className="error-text">Please enter a valid email</p>
                )}
              </div>
              <div
                className={
                  userName === "" || Object.keys(errors).length !== 0
                    ? "btn-filled-disabled"
                    : "btn-filled"
                }
                style={{
                  width: "fit-content",
                  margin: "20px auto",
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
                onClick={handleNext}
              >
                Submit
              </div>
              <p>
                {" "}
                Note: We'll send you important updates about your health
                progress, appointment reminders, and personalized
                recommendations via email.
              </p>
            </>
          )}
        {!initialCondition && !isLoading &&
          questionnaire.length === 0 &&
          !symptomScorePage &&
          !props.fromLandingPage && (
            <div
              className="btn-filled"
              style={{
                width: "fit-content",
                margin: "20px auto",
                display: "flex",
                justifyContent: "center",
                textAlign: "center",
              }}
              onClick={handleNext}
            >
              Submit
            </div>
          )}
      </div>
      <Loader active={isLoading} />
    </Popup>
  );
};

export default SymptomCalculator;
